<template>
  <div class="container-fluid p-0">
    <div class="row m-0">
      <div class="col-12 p-0">
        <div class="login-card">
          <div>
            <div><a class="logo"><router-link to="/"><img class="img-fluid" src="@/assets/images/logo/logo.png"
                    alt="logo image"></router-link></a></div>
            <div class="login-main">
              <form class="theme-form">
                <h2 class="text-center">Sign in to account</h2>
                <p class="text-center">Enter your email & password to login</p>
                <div class="form-group">
                  <label class="col-form-label">Email Address</label>
                  <input class="form-control" type="email" required="" placeholder="Test@gmail.com">
                </div>
                <div class="form-group">
                  <label class="col-form-label">Password</label>
                  <div class="form-input position-relative">
                    <input class="form-control" type="password" name="login[password]" required=""
                      placeholder="*********">
                    <div class="show-hide"><span class="show"> </span></div>
                  </div>
                </div>
                <div class="form-group mb-0">
                  <div class="checkbox p-0">
                    <input id="checkbox1" type="checkbox">
                    <label class="text-muted" for="checkbox1">Remember password</label>
                  </div><router-link class="link" to="/authentication/forgetpassword">Forgot password?</router-link>
                  <div class="text-end mt-3">
                    <router-link to="/"><button class="btn btn-primary btn-block w-100">Sign in</button></router-link>
                  </div>
                </div>
                <div class="login-social-title">
                  <h3>Or Sign in with </h3>
                </div>
                <div class="form-group">
                  <ul class="login-social">
                    <li><a href="https://www.facebook.com" target="_blank"><i class="fa fa-facebook"></i></a></li>
                    <li><a href="https://www.linkedin.com" target="_blank"><i class="fa fa-linkedin"> </i></a></li>
                    <li><a href="https://www.twitter.com" target="_blank"><i class="fa fa-twitter"></i></a></li>
                    <li><a href="https://www.instagram.com" target="_blank"><i class="fa fa-instagram"></i></a></li>
                  </ul>
                </div>
                <p class="mt-4 mb-0 text-center">Don't have account?<router-link class="ms-2"
                    to="/authentication/register">Create Account</router-link></p>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
export default {
    
}
</script>